<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
// 修改主题颜色只需要更改颜色表
// 图标
@import './assets/css/icon_font.css';
// B2B图标
@import './assets/font_B2B/iconfont.css';
// 颜色表
@import './assets/css/color/color.scss';
// 按钮文本主题颜色
@import './assets/css/index.scss';
// 标题菜单主题颜色
@import './assets/css/basecss.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue